/**
 * The foot of a queue card: when it was flagged, or who resolved it and when.
 *
 * `--nb-muted` (5.89:1) throughout, not `--nb-subtle` — at 11–11.5px that was
 * 4.13:1, and this line carries the flag age and the resolver's name.
 */
import { Avatar } from '../../dashboards/primitives';
import { ageLabel, formatInstant, resolvedStamp } from '../reviewQueueModel';
import type { ReviewQueueItem } from '../reviewTypes';

const FOOTER_STYLE = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  marginTop: 11,
  paddingTop: 10,
  borderTop: '1px solid var(--nb-border)',
} as const;

export default function ReviewQueueCardFoot({ item }: { item: ReviewQueueItem }) {
  const stamp = resolvedStamp(item);
  return (
    <div style={FOOTER_STYLE}>
      <span style={{ fontSize: 11.5, color: 'var(--nb-muted)' }}>
        {stamp ? (
          `Resolved ${stamp.at} · ${stamp.name}`
        ) : (
          <span title={formatInstant(item.flaggedAt)}>Flagged · {ageLabel(item.ageDays)}</span>
        )}
      </span>
      <span style={{ flex: 1 }} />
      {stamp && <Avatar name={stamp.name} size={26} />}
    </div>
  );
}
